<template>
<div id="reporte_abonos_fracciones" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="REPORTES DE ABONOS - FRACCIONES" class="elevation-1 px-5 py-3" >
          <br>

              <div class="contenedor-tab-reportes" >
                <v-card-text>
                  <v-card-subtitle v-if="model.tipo_reporte == 1">
                    <small class="red--text">*Los campos de “FECHA” requeridos para este módulo, se refieren a un periodo definido por rango (ejemplo: del 01-enero-2015 al 31-diciembre-2018).</small>
                  </v-card-subtitle>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                      <v-col sm="4" md="4" lg="4">
                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos"
                          :hide-no-data="true" :return-object="false" item-text="text" item-value="id"
                          label="Filtrar Por" @change="clear_values()" :rules="[rules.required]" >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row v-if="model.tipo_reporte == 2" row wrap>
                      <v-col cols="6" >
                        <v-combobox v-model="lista_filtrada" label="Lista de Folios" multiple persistent-hint small-chips disabled color="green">
                        </v-combobox>
                      </v-col>
                      <v-col cols="2" >
                        <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                          <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                      <v-row row wrap v-if="model.tipo_reporte == 1">
                        <v-col cols="12" sm="6" md="6" lg="6" >
                          <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu1 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6" >
                          <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu2 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                      </v-row>
                      <v-row no-row wrap>
                            <v-col cols="12" sm="2" lg="2">
                              <v-autocomplete v-model="tipo_filtro" :items="tipos_filtros" :hide-no-data="true" :return-object="false" label="Tipo de Filtro" item-value="id" @change="model.fraccion = [];"/>
                            </v-col>
                            <v-col cols="12" md="2" sm="2" lg="2">
                                <v-autocomplete v-model="model.activo" :items="list_activos" :hide-no-data="true"
                                    item-text="text" item-value="id"
                                    :return-object="false"  label="Activo Fijo"
                                    @change="getFracciones()">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="5" sm="5" lg="5">
                                <v-autocomplete v-if="tipo_filtro==1" v-model="model.fraccion" :items="fracciones" :hide-no-data="true" :return-object="false" label="Seleccione una Fracción" multiple small-chips deletable-chips :rules="[validaFracciones]" :loading="loadingfracciones">
                                  <template slot="message">
                                    <div style="margin-top:15px">
                                      Máximo 5 Fracciones
                                    </div>
                                  </template>
                                </v-autocomplete>
                                <v-text-field v-if="tipo_filtro==2" v-model="model.fraccion" label="Fracciones" prepend-icon="fa-search" disabled></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" lg="3" v-if="tipo_filtro==2">
                              <v-btn icon title="Pegar Listado" @click="listado=''; dialog2 = !dialog2; model.fraccion = [];" v-tippy>
                                <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                              </v-btn>
                            </v-col>

                      </v-row>
                    </v-container>

                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="success" @click="generar_reporte_sqs" >
                    <v-icon>done</v-icon>Generar Reporte
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <v-refresh-button :funcion="cargarReportes" />
                  <v-client-table ref="vuetable" :data="datos.reportes" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>

                    <template slot="actions" slot-scope="props" >
                      <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>

        </base-material-card>
      </v-col>
    </v-row>
  </v-container>

  <v-dialog v-model="dialog1" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de Folios</h5>
        <span>Uno por línea</span>
        <v-form ref="formListado" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="listado" :rules="[validaListado]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="listado=''; lista_filtrada=[]; dialog1 = false" >Cancelar</v-btn>
        <!--v-btn small color="primary" @click="generaReporteListado()" >Buscar</v-btn-->
        <v-btn small color="primary" @click="setListValues();">Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="dialog2" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de Fracciones</h5>
        <span>Uno por línea</span>
        <v-form ref="formListadoFracciones" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="listado_fracciones" :rules="[validaListadoFracciones]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="listado_fracciones=''; dialog2 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="agregar_fracciones" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
  components: {
    "v-refresh-button": RefreshButton,
  },
  created: function() {
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.loading = false;
    this.tipo = 1;
    this.model.rfc = this.$local_storage.get("rfc");
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.getFracciones();
    this.getFracciones_s();
    this.cargarReportes();
  },
  computed: {
  },
  data: () => ({
    dialog1: false,
    dialog2: false,
    listado:'',
    listado_fracciones:'',
    tipos: [{
        "id": 1,
        "text": "Por Fechas de Aplicación Informe"
      }, {
        "id": 2,
        "text": "Por Folio | Listado de Folios"
      },
    ],
    tipo_filtro:1,
    tipos_filtros:[
      {"id":1, "text": "Selección de Fracción"},
      {"id":2, "text": "Listado de Fracciones"}
    ],
    fracciones_n:[],
    fracciones_s:[],
    loadingfracciones:false,
    permisoEliminar:false,
    list_activos:[
        {"id":"N","text":"No"}, //No Activo Fijos
        {"id":"S","text":"Si"}, //Activo Fijo
        {"id":"","text":"Todos"}],
    fracciones: [],
    fab: false,
    rfc: '',
    tipo: '',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Reportes",
        disabled: true,
        to: ""
      },
      {
        text: "Abonos",
        disabled: true,
        to: ""
      },
      {
        text: "Por Fracción",
        disabled: true,
        to: ""
      }
    ],
    datos: {
      reportes: [],
      reportesPartidas: [],
      reportesDescargos: [],
    },
    columns_reportes: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options_reportes: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: false,
    show_loading: true,
    list_reportes: [
            {
                "reporte": "Pref. Arancelarias Activo Fijo WS",
                "url": "/reportes_ws/partidas_activo_fijo/"
            },
            {
                "reporte": "Pref. Arancelarias Activo Fijo DS",
                "url": "/reportes_ds/partidas_activo_fijo_ds/"
            },
    ],
    model: {
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a: "",
      activo: "",
      fraccion: [],
      reporte_url: "/soluciona31/reportes/rpt_abonos_fracciones/",
      nombre_reporte: "Abonos Por Fracción",
      tipo: "SA31_Abonos_Fracciones",
      tipo_reporte: 1,
    },

    selecciona_todo8: false,
    selecciona_todo8_partida: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,
    lista_filtrada: [],
  }),
  methods: {
    setListValues: function() {
      this.lista_filtrada = [];
      let to_list = this.get_array_lista(this.listado);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada.push(to_list[i]);
        }
      }
      this.model.fecha_de = "";
      this.model.fecha_a = "";
      this.dialog1 = !this.dialog1;
    },
    get_array_lista: function(cadena) {
      try {
        var newarr = [];
        if (cadena != undefined) {
          let data = cadena.split("\n");
          newarr = data.filter(a => a.trim() !== '');
          for (var i = 0; i < newarr.length; i++) {
            newarr[i] = newarr[i].trim();
            newarr[i] = newarr[i].replace(',', '');
            newarr[i] = newarr[i].replace('.', '');
          }
        }
        return newarr;
      } catch (error) {
        console.log(error);
      }
    },
    clear_values() {
      this.model.folio = '';
      this.model.fecha_de = '';
      this.model.fecha_a = '';
      this.listado = "";
    },
    agregar_fracciones: function() {
      if (this.$refs.formListadoFracciones.validate()) {
        this.model.fraccion = this.removerLineasVacias(this.listado_fracciones);
        this.listado_fracciones = String('');
        this.dialog2 = false;
      }
    },
    validaListadoFracciones: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado_fracciones);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 fracción. Favor de verificar.";
      } else if (listadoSinEspacios.length > 25) {
        return "No se puede consultar mas de 25 Fracciones";
      } else {
        const pattern = /^[\d]{8}$/;
        for (var k in listadoSinEspacios) {
          if (!pattern.test(listadoSinEspacios[k])){
            return "Formato de Fracción Invalido";
          }
        }
      }
      return true;
    },
    validaListado: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 folio. Favor de verificar.";
      } else if (listadoSinEspacios.length > 250) {
        return "No se puede consultar mas de 250 folios";
      }
      return true;
    },
    removerLineasVacias(listado) {
      var listadoSplit = listado.split("\n");
      var listadoSinEspacios = listadoSplit.filter(item => {
        return item.trim() != "";
      });
      return listadoSinEspacios;
    },
    generaReporteListado() {
      if (this.$refs.formListado.validate() && this.model.nombre_reporte!="") {
        this.generar_reporte_sqs(1);
        this.dialog1 = false;
      }
    },
    validaMes: function() {
        if (this.model.fecha_de != null && this.model.fecha_a != null && this.model.fecha_de != "" && this.model.fecha_a != "") {
            var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
            var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
            var diferencia = fin.diff(inicio, 'days')
            if (diferencia < 0)
                return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            if (Math.abs(diferencia) > 31)
                return "Periodo máximo de consulta 31 días. Favor de verificar.";
        }
        return true;
    },
    setNombreReporte: function () {
        var url = this.model.reporte_url
        var search = this.list_reportes.filter(function (e) {
            return e.url == url;
        });
        if (search.length > 0) {
            this.model.nombre_reporte = search[0].reporte;
        }
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    getFracciones:function(){

        this.fracciones = [];
        if(this.model.activo == "N"){
          if (this.fracciones_n.length>0){
            this.fracciones = this.fracciones_n;
          }
        } else {
          if (this.fracciones_s.length>0){
            this.fracciones = this.fracciones_s;
          }
        }

        if (this.fracciones.length == 0) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.loadingfracciones = true;
          var data = {
              "identificador": this.model.activo, //identificador de activo fijo N -> No, S -> Si
              "rfc": this.model.rfc
          };

          axios({
              method: "post",
              url: this.$apiSA31 + "soluciona31/reportes/get_fracciones_inventario/",
              data: data
            })
            .then(response => {
                  if(response.data && response.data.length){
                      this.fracciones = response.data;
                      if(this.model.activo == "N"){
                          this.fracciones_n = response.data;
                      } else {
                          this.fracciones_s = response.data;
                      }
                  } else {
                      this.fracciones = [];
                  }
            }).catch(error => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al obtener las fracciones. Intente nuevamente.",
                footer: ""
              });
            }).then(() => {
              this.loadingfracciones = false;
              this.$root.$dialogLoader.hide();
            });
        }

    },
    getFracciones_s:function(){

      var data = {
          "identificador": "S", //identificador de activo fijo N -> No, S -> Si
          "rfc": this.model.rfc
      };

      axios({
          method: "post",
          url: this.$apiSA31 + "soluciona31/reportes/get_fracciones_inventario/",
          data: data
        })
        .then(response => {
              if(response.data && response.data.length){
                  this.fracciones_s = response.data;
              }
        }).catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener las fracciones. Intente nuevamente.",
            footer: ""
          });
        });


    },
    validaFracciones: function() {
      if(this.model.fraccion.length > 5) {
        this.$swal({
          type: "info",
          title: "¡Advertencia!",
          text: "Solo puedes seleccionar máximo 5 fracciones.",
          footer: ""
        });
        this.model.fraccion.pop();
        return "Máximo 5 fracciones";
      }

      return true;
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    generar_reporte_sqs() {
      if (this.model.tipo_reporte == 2 && this.lista_filtrada.length == 0) {
        this.$swal({
            type: "info",
            title: "¡Operación no Permitida!",
            text: "Debe agregar al menos 1 folio.",
            footer: ""
          });
      } else if (this.model.tipo_reporte == 1 && !this.$refs.form.validate()) {
        
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;

        if(this.model.tipo_reporte == 2){//Busqueda por listado
          data["lista"] = this.removerLineasVacias(this.listado);
          data.folio = '';
        }

        if (data.folio == '') delete(data['folio']);
        if (data.fecha_de == '') delete(data['fecha_de']);
        if (data.fecha_a == '') delete(data['fecha_a']);

        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/save_reporte/",
            data: data
          })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.cargarReportes();
            this.$root.$dialogLoader.hide();
          });
      }
    },
    cargarReportes: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "SA31_Abonos_Fracciones"
      };
      axios.post(this.$apiSA31+ "soluciona31/reportes/get_reportes/", data)
        .then(res => {
          if (res.data != undefined) {
            this.datos.reportes = res.data;
            this.datos.reportes.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
            });
            for (var k in this.datos.reportes) {
              this.datos.reportes[k].fecha_solicitud = this.parseDate(this.datos.reportes[k].fecha_solicitud);
              this.datos.reportes[k].fecha_generacion = this.parseDate(this.datos.reportes[k].fecha_generacion);
              this.datos.reportes[k].estatus = this.getEstatus(this.datos.reportes[k].estatus);
              this.datos.reportes[k].criterio = this.getCriterioPredeterminadosDS(this.datos.reportes[k].criterio);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },

    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminadosDS: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          if(params.tipo_reporte != undefined && params.tipo_reporte == 2) {
            return "Por Folio";
          } else {
            return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
          }
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$apiSA31 + 'soluciona31/reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargarReportes();
            });
        }
      });
    },
  },
};
</script>
<style scoped>

</style>
